/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ApplicationEnum = 1 | 2 | 3;

export const ApplicationEnum = {
    NUMBER_1: 1 as ApplicationEnum,
    NUMBER_2: 2 as ApplicationEnum,
    NUMBER_3: 3 as ApplicationEnum
};